<!--
 Copyright 2023, Avation Medical. All rights reserved.
 
 This code is proprietary and confidential information of Avation Medical. Any use, reproduction, modification
 or distribution of the code without the express prior written consent of Avation Medical is strictly prohibited.
-->

<div class="login-page">
    <div class="login-header">
        <button class="push-button back-button tertiary warrenty-back-btn back-btn-position" style="width: auto !important;" [routerLink]="['../..']">
            <mat-icon svgIcon="back"></mat-icon>
        </button>
        <div class="logo-wrapper">
            <img src="/assets/icons/vivally-logo.svg"/>
        </div>
    </div>
    <div class="login-body">
        <div class="login-text">
            <span>The password must be at least 8 characters, including a number, one upper case, one lower case, and one special character {{"($%#@*&!)"}}</span>
        </div>

        <div class="login-block">
            <form class="login-form" [formGroup]="changePasswordForm" (ngSubmit)="submitForm()">
                <div class="form-box">
                    <mat-label>Old Password</mat-label>
                    <mat-form-field>
                        <input id="oldPassword" matInput placeholder="Old Password" [type]="hidePasswordOld ? 'password' : 'text'" formControlName="oldPassword">
                        <mat-icon id="visibility" matSuffix (click)="hidePasswordOld = !hidePasswordOld">{{hidePasswordOld ? 'visibility' : 'visibility_off'}}</mat-icon>
                    </mat-form-field>
                </div>
    
                <div class="form-box">
                    <mat-label>New Password</mat-label>
                    <mat-form-field>
                        <input id="newPassword" matInput placeholder="New Password" [type]="hidePasswordNew ? 'password' : 'text'" formControlName="newPassword">
                        <mat-icon id="visibility" matSuffix (click)="hidePasswordNew = !hidePasswordNew">{{hidePasswordNew ? 'visibility' : 'visibility_off'}}</mat-icon>
                    </mat-form-field>
                </div>
    
                <div class="form-box">
                    <mat-label>Confirm New Password</mat-label>
                    <mat-form-field>
                        <input id="confirmPassword" matInput placeholder="Confirm New Password" [type]="hidePasswordConfirm ? 'password' : 'text'" formControlName="confirmPassword">
                        <mat-icon id="visibilityConfirm" matSuffix (click)="hidePasswordConfirm = !hidePasswordConfirm">{{hidePasswordConfirm ? 'visibility' : 'visibility_off'}}</mat-icon>
                    </mat-form-field>
                </div>
    
                <div class="login-block" *ngIf="!loading; else while_loading">
                    <div>
                        <button id="setPasswordBtn" class="push-button primary" type="submit" [disabled]="!changePasswordForm.valid">Set Password</button>
                    </div>
                    <div class="error-text">
                        <div id="errorStr" *ngIf="errorStr">{{this.errorStr}}</div>       
                    </div>
                </div>
                <ng-template #while_loading>
                    <mat-progress-spinner class="progress-spinner" color="primary" mode="indeterminate"></mat-progress-spinner>
                </ng-template>
            </form>
        </div>
    </div>
    <vivally-footer></vivally-footer>
</div>